module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2"
  }, [_c('a', {
    attrs: {
      "id": "pre"
    }
  }), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('strong', [_vm._v("Prefatory Note")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This volume contains revised versions of most of the papers and discussions presented at the Conference on Research in Income and Wealth entitled “Wealth, Financial Intermediation and the Real Economy,” held in Washington, DC, on November 12–13, 2010. We thank the Board of Governors of the Federal Reserve System for graciously hosting the conference.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We gratefully acknowledge the financial support for this conference provided by the Bureau of Economic Analysis. Support for the general activities of the Conference on Research in Income and Wealth is provided by the following agencies: Bureau of Economic Analysis, Bureau of Labor Statistics, Census Bureau, Board of Governors of the Federal Reserve System, Internal Revenue Service, and Statistics Canada.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We thank Charles R. Hulten and Marshall B. Reinsdorf, who served as editors of the volume, as well as Michael Palumbo, who served as a conference organizer along with the editors.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Executive Committee, September 2013")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("John M. Abowd")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Susanto Basu")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Andrew Bernard")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ernst R. Berndt")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Carol A. Corrado")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("W. Erwin Diewert")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Robert C. Feenstra")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("John Greenlees")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("John C. Haltiwanger")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Michael W. Horrigan")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Charles R. Hulten (chair)")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Ron Jarmin")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("J. Steven Landefeld")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Brent Moulton")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Valerie Ramey")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Mark J. Roberts")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Daniel Sichel")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("William Wascher")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e32a6fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/9780226204437_07_pre.vue
// module id = 75
// module chunks = 0